<template>
  <div class="uploader-list">
    <slot :file-list="fileList">
      <ul>
        <li v-for="file in fileList" :key="file.id">
          <uploader-file :file="file" :list="true"></uploader-file>
        </li>
      </ul>
    </slot>
  </div>
</template>

<script>
import UploaderFile from './file.vue';

export default {
    name: 'uploader-list',
    computed: {
        fileList () {
            return this.$parent.fileList;
        }
    },
    components: {UploaderFile}
};
</script>

<style lang="scss">
  .uploader-list {
      position: relative;
      > ul {
          list-style: none;
          margin: 0;
          padding: 0;
          li+li{
              margin-top:2px
          }
      }
  }
</style>
